import { render } from "./NumberDetail.vue?vue&type=template&id=4dd1d594"
import script from "./NumberDetail.vue?vue&type=script&lang=js"
export * from "./NumberDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__